import { last } from 'lodash/fp';
import { useStepperContext } from '@ahmdigital/ui';
import React from 'react';

import { analyticsLabels } from '../../constants';
import { StyledButton, StyledClickable } from '../step-footer-navigation/styles';

type Props = {
  onNextClick?: Function;
};

const ForwardButtons = ({ onNextClick }: Props) => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'activeStep' does not exist on type '{}'.
  const { activeStep, goToNextStep, steps } = useStepperContext();

  const isLastStep = activeStep === last(steps);
  const isServicesStep = activeStep?.includes('services');

  const handleOnNextClick = () => {
    if (onNextClick) {
      onNextClick();
    } else {
      goToNextStep();
    }
  };

  if (!isServicesStep && isLastStep) {
    return null;
  }

  return (
    <>
      {isServicesStep && goToNextStep && (
        <StyledClickable analytics={{ label: `Skip - ${analyticsLabels[activeStep]}` }} onClick={goToNextStep}>
          Skip
        </StyledClickable>
      )}
      {!isLastStep && (
        <StyledButton analytics={{ label: `Next - ${analyticsLabels[activeStep]}` }} onClick={handleOnNextClick}>
          Next
        </StyledButton>
      )}
    </>
  );
};

export default ForwardButtons;
